// extracted by mini-css-extract-plugin
module.exports = {"grey200":"#E6E6EC","grey400":"#7D7D84","error":"#E9283A","currencyWrapper":"CurrencyInput_currencyWrapper__9_G1C","currencyCode":"CurrencyInput_currencyCode__xMRpJ"};